import React, { useState } from 'react';
import ClusterWaveformGroups from './ClusterWaveformGroups';
import './WaveformSingleChannelView.css';

export default function ClusterWaveformWidget({ selectedClusters = [], clusterWaveforms = {},
  clusterData, loadNeighbors = false, dataCacheScope, highlightedSpike }) {
  const [layout, setLayout] = useState('split');
  return <div className="waveform-single-channel-view cluster-waveform-widget">
    <label className="waveform-mode-selector">Channels{' '}
      <select aria-label="Waveform layout" value={layout} onChange={event => setLayout(event.target.value)}>
        <option value="split">Neighboring channels</option>
        <option value="individual">Primary channel only</option>
      </select>
    </label>
    <div className="waveform-plot-container">
      {!selectedClusters.length ? <div className="no-data-message">
        <p>Select clusters from a linked widget to compare their waveforms by primary channel.</p>
      </div> : <ClusterWaveformGroups selectedClusters={selectedClusters} clusterData={clusterData}
        clusterWaveforms={clusterWaveforms} stacked={layout === 'split'} loadNeighbors={loadNeighbors}
        dataCacheScope={dataCacheScope} highlightedSpike={highlightedSpike} />}
    </div>
  </div>;
}
